
'use client'
import React, { useEffect, useState } from 'react'
import styles from './footer.module.css'
import { FacebookIcon, InstaIcon, LinkdinIcon, TwitterIcon } from '../../../../Svg'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getAppearances } from '../../../../redux/homeSlice'
import { getSubCategoryNames } from '../../../../redux/productsSlice'



const Footer = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { appearanceData } = useSelector((state) => state.appearances);
    const { categoryNamesData, } = useSelector((state) => state.products);
    //   console.log('popularProductsData', popularProductsData);

    const [isSubCategoryOpen, setIsSubCategoryOpen] = useState(false);

    //categories
    const categoriesData = appearanceData?.categories
    const [hoveredCategory, setHoveredCategory] = useState(null);

    const handleCategoryHover = (categoryId) => {
        if (hoveredCategory !== categoryId) {
            setHoveredCategory(categoryId);
            dispatch(getSubCategoryNames(`?categoryId=${categoryId}`));  // Fetch subcategories when hovering
        }
    };
    useEffect(() => {
        dispatch(getAppearances())
    }, [dispatch])

    return (
        <div className={styles.container}>
            <div className={styles.footerNav}>
                <div className={styles.footerNavBox}>
                    <h2>Need Help</h2>
                    <ul>
                        <a href="/contact"><li>Contact Us</li></a>
                        <a href="/aboutus"><li>About Us</li></a>
                        {/* <a href="/metro-guide"><li>Metro Guide</li></a> */}
                    </ul>
                </div>
                <div className={styles.footerNavBox}>
                    <h2>Categories</h2>
                    <ul>
                        {categoriesData?.map((category) => (
                            <li key={category._id}
                                className={styles.dropdownContainer}
                                onMouseEnter={() => handleCategoryHover(category._id)}
                                onMouseLeave={() => setHoveredCategory(null)} >
                                <div className={styles.dropdownTrigger}
                                    onClick={() =>
                                        navigate(`/product/${category?._id}`, { state: category?.name })
                                    }
                                >
                                    {category?.name}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className={styles.footerNavBox}>
                    <h2>More Info</h2>
                    <ul>
                        <a href="/termsCondition"><li>Terms & Conditions</li></a>
                        <a href="/internationalPolicy"><li>International Shipping</li></a>
                        <a href="/privacyPolicy"><li>Privacy Policy</li></a>
                        <a href="/returnRefund"><li>Refund & Cancellation Policy</li></a>
                        <a href="/faq"><li>FAQ's</li></a>
                    </ul>
                </div>
                <div className={styles.footerNavBox}>
                    <h2>Location</h2>
                    <ul>
                        <li
                            onClick={() =>
                                window.open(
                                    "https://www.google.com/maps/place/PAVITHRA+JEWELS/@12.985862,77.537084,14z/data=!4m6!3m5!1s0x3bae3dc069250789:0x735c09fe44e27e5a!8m2!3d12.9858624!4d77.5370835!16s%2Fg%2F124t32q14?hl=en&entry=ttu&g_ep=EgoyMDI1MDcyMS4wIKXMDSoASAFQAw%3D%3D",
                                    "_blank"
                                )
                            }
                            className={styles.addressLine}>#6/7, Giriyappa Complex, F-38, 80 Feet Road, 1st Stage, KHB Colony, Basaveshwaranagar, Bengaluru, Karnataka - 560079, INDIA.
                        </li>
                        <li>Contact No: 080-41287034</li>
                        <li>+91-9845540125 </li>
                        <li>+91-9632429387</li>
                        <li><a href="http://www.pavithrajewels.com" target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: "none", textTransform: "lowercase" }} >www.pavithrajewels.com</a> </li>
                    </ul>
                </div>
            </div>
            <div className={styles.icons}>
                <a href="https://www.facebook.com/share/1BjEDMYRDF/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                    <img src='/Facebook_logo.jpg' alt='facebook' />
                </a>

                <a href="https://www.instagram.com/pavithra_jewels?igsh=NzZ5c2xscmdvenZ2&utm_source=qr" target="_blank" rel="noopener noreferrer">
                    <img src='/Instagram_icon.png' alt='instagram' />
                </a>
                <img src='/frame.png'
                    onClick={() =>
                        window.open(
                            "https://www.google.com/maps/place/PAVITHRA+JEWELS/@12.985862,77.537084,14z/data=!4m6!3m5!1s0x3bae3dc069250789:0x735c09fe44e27e5a!8m2!3d12.9858624!4d77.5370835!16s%2Fg%2F124t32q14?hl=en&entry=ttu&g_ep=EgoyMDI1MDcyMS4wIKXMDSoASAFQAw%3D%3D",
                            "_blank"
                        )
                    }
                />
            </div>

            <div className={styles.footerfoot}>
                <div className={styles.line}></div>
                <div className={styles.copywrite}>
                    <p>
                        Copyright ©️2025 PAVITHRA JEWELS. All Rights Reserved.
                    </p>
                </div >
            </div>
        </div>
    )
}

export default Footer